
import {Link} from "react-router-dom"
import Softtek from "../../resources/images/logo-white.svg"


const Logo = () => {
    return(
        <Link to={'/'} className="Softtek">
            <img alt="logo softtek" src={Softtek} className="MainLogo" />
            <span className="ProductName">Campaign</span>
        </Link>
    );
}

export default Logo;